import type { Locale } from "@/lib/i18n";
import { pl, type CJobOffersTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cJobOffersTranslations: Record<Locale, CJobOffersTranslations> = {
  pl,
  en,
  de,
};

export type { CJobOffersTranslations };
